/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_Description_ColInputs */

const en_settings_credits_description_col = /** @type {(inputs: Settings_Credits_Description_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Settings_Credits_Description_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_credits_description_col = /** @type {((inputs?: Settings_Credits_Description_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_Description_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_credits_description_col(inputs)
});
export { settings_credits_description_col as "settings.credits.description_col" }